module.exports = __webpack_public_path__ + "img/summary-3.2eacb6f9.svg";